import { saleReportRangeError } from "@/helpers/crmSaleReport";
import $api from "../Api";
import ResponseChecker from "../Middlewares/ResponseChecker";
import { defaultMessages } from "../enums/responseMessages.js";
import Endpoints from "../Endpoints";
function validateRange(options) {
  const error = saleReportRangeError(options?.query);
  if (error) throw new Error(error);
}
export const GetSummary = async (options) => {
  validateRange(options);
  return ResponseChecker(
    defaultMessages,
    await $api.get(Endpoints.CrmSaleReport.GetSummary(options))
  );
};
export const GetDetails = async (options) => {
  validateRange(options);
  return ResponseChecker(
    defaultMessages,
    await $api.get(Endpoints.CrmSaleReport.GetDetails(options))
  );
};
export const GetBrandSummary = async (options) => {
  validateRange(options);
  return ResponseChecker(
    defaultMessages,
    await $api.get(Endpoints.CrmSaleReport.GetBrandSummary(options))
  );
};
export default { GetSummary, GetDetails, GetBrandSummary };
